import React from "react";
import { Link } from "react-router-dom";

function Contactus({ contactDetails }) {
  return (
    <div>
      <section className="contact-us">
        <h2>contact us</h2>
        <p>
          If you have any question, feedback, or need assistance, our dedicated
          support team is here to help.
        </p>
        <div className="grid-3">
          {contactDetails.map((contact) => (
            <div key={contact.id}>
              <figure>
                <div className="img-container">
                  <img src={contact.icon} alt="contact icon" />
                </div>
                <h5>{contact.title}</h5>
                <p>{contact.description}</p>
                {contact.info === "send message" ? (
                  <Link to={`mailto:solobachi02@gmail.com`} className="cta-btn">
                    {contact.info}
                    <span>
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="31"
                        height="2"
                        viewBox="0 0 31 2"
                        fill="none"
                      >
                        <path
                          d="M1.83325 1H29.8832"
                          stroke="white"
                          stroke-width="2"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </Link>
                ) : (
                  <span>{contact.info}</span>
                )}
              </figure>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Contactus;
